module.exports = "<fa-icon icon=\"copy\" title=\"{{tooltip}}\" [class]=\"css_class\" style=\"cursor: pointer;\" (click)=\"copy_text()\"></fa-icon>\n"